<div class="wsd-user-count-tab">
    <div class="ui-g">
        <div class="ui-g-12">
            <div class="p-grid">
                <div class="p-col-3">
                    <label class="ui-custom-label">{{ 'USER_REPORTS.USER_COUNT_TAB.TOTAL_REG_USERS' |
                        translate}}</label>
                    <h2 class="count-value m-t-10">{{userTotalCount}}</h2>
                </div>
                <div class="p-col-3">
                    <label class="ui-custom-label">{{ 'USER_REPORTS.USER_COUNT_TAB.TOTAL_REG_FILTER' |
                        translate}}</label>
                    <h2 class="count-value m-t-10">{{userFilteredCount}}</h2>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="wsd-user-count-tab">
    <form [formGroup]="userCountForm">
        <div class="ui-g">
            <div class="ui-g-12">
                <div class="p-grid">
                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.USER_COUNT_TAB.REG_FROM' | translate}}</label>
                        <wsd-extended-input [control]="userCountForm.get('dateFrom')">
                            <p-calendar wsdUseUtc [showIcon]="true" dateFormat="dd/mm/yy"
                                [maxDate]="userCountForm.get('dateTo').value" formControlName="dateFrom"
                                placeholder="{{ 'USER_REPORTS.USER_COUNT_TAB.SELECT_DATE_PLACEHOLDER' | translate }}"
                                [monthNavigator]="true" [yearNavigator]="true" [yearRange]="dateRange">
                            </p-calendar>
                        </wsd-extended-input>
                        <div class="filter-row">
                            <button pButton class="ui-button-custom-primary inline-block width-full-parent w-70"
                                label="{{ 'USER_REPORTS.USER_COUNT_TAB.FILTER' | translate}} " (click)="filter()">
                            </button>
                            <button pButton class="ui-button-custom-secondary inline-block width-full-parent"
                                label="{{ 'USER_REPORTS.USER_COUNT_TAB.RESET' | translate}} " (click)="resetValue()">
                            </button>
                        </div>
                    </div>
                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.USER_COUNT_TAB.REG_TO' | translate}}</label>
                        <wsd-extended-input [control]="userCountForm.get('dateTo')">
                            <p-calendar wsdUseUtc [showIcon]="true" dateFormat="dd/mm/yy"
                                [minDate]="userCountForm.get('dateFrom').value" formControlName="dateTo"
                                [monthNavigator]="true" [yearNavigator]="true" [yearRange]="dateRange"
                                placeholder="{{ 'USER_REPORTS.USER_COUNT_TAB.SELECT_DATE_PLACEHOLDER' | translate }}">
                            </p-calendar>
                        </wsd-extended-input>
                    </div>

                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.USER_COUNT_TAB.REGION' | translate}}</label>
                        <p-multiSelect [options]="regionItems"
                            defaultLabel="{{ 'USER_REPORTS.USER_COUNT_TAB.REGION_PLACEHOLDER' | translate }}"
                            formControlName="regions"
                            [class.placeholder]="!userCountForm.get('regions').value || userCountForm.get('regions').value.length === 0">
                        </p-multiSelect>
                        <button pButton class="ui-button-custom-primary inline-block width-full-parent w-100"
                            label="{{ 'USER_REPORTS.USER_COUNT_TAB.EXPORT_PER_REGION' | translate}} "
                            (click)="exportByRegion()">
                        </button>
                    </div>

                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.USER_COUNT_TAB.COUNTRY' | translate}}</label>
                        <p-multiSelect [options]="countryItems"
                            defaultLabel="{{ 'USER_REPORTS.USER_COUNT_TAB.COUNTRY_PLACEHOLDER' | translate }}"
                            formControlName="countries"
                            [class.placeholder]="!userCountForm.get('countries').value || userCountForm.get('countries').value.length === 0">
                        </p-multiSelect>
                        <button pButton class="ui-button-custom-primary inline-block width-full-parent w-100"
                            label="{{ 'USER_REPORTS.USER_COUNT_TAB.EXPORT_PER_COUNTRY' | translate}} "
                            (click)="exportByCountry()">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
